<template>
  <SvgIcon
    v-if="status"
    :name="icon.name"
    :style="{ color: icon.color }"
    :class-name="status === 'running' ? 'job-status-rotate' : ''"
  />
</template>

<script setup>
import { computed } from "vue";
import { SvgIcon } from "../svg.js";

// Props
const props = defineProps({
  status: {
    type: String,
    default: "",
  },
});

// same status → icon/color mapping as the job/step v-if chains in
// RepoActionView.vue and ActionRunJobView.vue
const icon = computed(() => {
  switch (props.status) {
    case "success":
      return {
        name: "octicon-check-circle-fill",
        color: "var(--copia-teal-02)",
      };
    case "skipped":
      return { name: "octicon-skip", color: "var(--copia-grey-03)" };
    case "waiting":
      return { name: "octicon-clock", color: "var(--copia-orange-01)" };
    case "blocked":
      return { name: "octicon-blocked", color: "var(--copia-orange-01)" };
    case "running":
      return { name: "octicon-meter", color: "var(--copia-orange-01)" };
    default:
      return { name: "octicon-x-circle-fill", color: "var(--copia-red-01)" };
  }
});
</script>
